import { Injectable } from '@angular/core';
import { endpoints } from '@app/constants';
import { HttpService } from '@app/core/services/http';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import {
  TransferChartResponse,
  TransferChartsPayload,
  UpdateChartCustomNamePayload
} from '@app/core/features/charts-manager/my-charts/transfer-charts';

@Injectable({
  providedIn: 'root'
})
export class TransferChartsService {
  transferSuccess$ = new BehaviorSubject<boolean>(false);

  constructor(
    private http: HttpService
  ) { }

  startTransferChart = (payload: TransferChartsPayload): Observable<TransferChartResponse> => {
    return this.http
      .post({ url: endpoints.dealerTransfer, body: payload })
      .pipe(
        mergeMap(this.handleTransferChartResponse),
        catchError((error) => throwError(error))
      );
  }

  cancelTransferChart = (payload: string[]): Observable<TransferChartResponse> => {
    return this.http
      .post({ url: endpoints.dealerCancel, body: payload })
      .pipe(
        mergeMap(this.handleProcessChartResponse),
        catchError((error) => throwError(error))
      );
  }

  confirmTransferChart = (payload: string[]): Observable<TransferChartResponse> => {
    return this.http
      .post({ url: endpoints.dealerConfirm, body: payload })
      .pipe(
        mergeMap(this.handleProcessChartResponse),
        catchError((error) => throwError(error))
      );
  }

  updateChartCustomName = (payload: UpdateChartCustomNamePayload): Observable<any> => {
    return this.http
      .post({ url: endpoints.dealerUpdateChartCustomName, body: payload })
      .pipe(
        mergeMap(this.handleProcessChartResponse),
        catchError((error) => throwError(error))
      );
  }

  private handleTransferChartResponse = (response: any): Observable<any> => {
    return of(response);
  }

  private handleProcessChartResponse = (response: any): Observable<any> => {
    return of(response);
  }
}
